import {
  FETCH_NOTIFICATIONS,
  CREATE_NOTIFICATION,
  SHOW_NOTIFICATION,
  HIDE_NOTIFICATION,
  CREATE_PERMANENT_NOTIFICATION
} from './mutations-types'

export default {
  [FETCH_NOTIFICATIONS] (state, payload) {
    state.notifications = payload
  },
  [CREATE_NOTIFICATION] (state, payload) {
    state.notifications.push(payload.join(' '))
  },
  [SHOW_NOTIFICATION] (state, payload) {
    state.notification = payload
  },
  [HIDE_NOTIFICATION] (state) {
    state.notification = null
  },
  [CREATE_PERMANENT_NOTIFICATION] (state, payload) {
    state.permanentNotifications = [...state.permanentNotifications, payload]
  }
}
